import EnterpriseExperiments from 'bundles/epic/clients/__generated__/Enterprise';

export const createEnterpriseSearchExperimentImpression = () => {
  EnterpriseExperiments.get('enterpriseSearchShadow');
};
